<template>
    <v-card :loading="loading" min-height="500">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-card-title>
            <v-layout row wrap>
                <v-col cols="6">
                    {{ title }}
                </v-col>
                <v-col cols="6" class="text-right">
                    <v-btn
                        v-if="hasAddNewButton"
                        color="primary"
                        dark
                        class="ml-2"
                        :href="$router.resolve({ name: 'internal-aquisitions-create' }).href"
                        @click="addNewItem"
                    >
                        Adaugare
                    </v-btn>
                    <v-btn
                        color="primary"
                        dark
                        class="ml-2"
                        @click="createExport"
                    >
                        Export PDF
                    </v-btn>
                </v-col>
                <v-col md="5" sm="12">
                    <period-selector v-model="period" :button-class="['mt-3']"></period-selector>
                </v-col>
                <v-col md="4" sm="12">
                    <user-selector v-model="filterByUser" filter-by-role="achizitii"></user-selector>
                </v-col>
                <v-col md="3" sm="12" class="text-right">
                    <search-field v-model="search"></search-field>
                </v-col>
            </v-layout>
            <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="headline">Sunteti sigur ca doriti stergerea intrarii?</v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeDelete">Anulare</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">Confirmare</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            class="elevation-1"
        >
            <template v-slot:item.offer_date="{ item }">
                {{ new Date(item.document_date) | date }}
            </template>
            <template v-slot:item.supplier_id="{ item }">
                {{ item.supplier.name }}
            </template>
            <template v-slot:item.amount_with_vat="{ item }">
                {{ item.amount_with_vat | price }}
            </template>
            <template v-slot:item.equipment_id="{ item }">
                {{ _.get(item, 'equipment.brand', '-') }} / {{ _.get(item, 'equipment.model', '-') }}
            </template>
            <template v-slot:item.created_by="{ item }">
                {{ _.get(item, 'created_by.name', '-') }} ({{ _.get(item, 'created_by.email', '-') }})
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn
                    v-if="canUpdate(item)"
                    outlined
                    x-small
                    fab
                    class="mr-2"
                    color="primary"
                    :href="$router.resolve({ name: 'offers-edit', params: { id: item.id } }).href"
                    @click="editItem($event, item)"
                >
                    <v-icon>
                        mdi-pencil
                    </v-icon>
                </v-btn>
                <v-btn
                    v-if="canDelete(item)"
                    outlined
                    x-small
                    fab
                    class="mr-2"
                    color="error"
                    @click="deleteItem(item)"
                >
                    <v-icon>
                        mdi-delete
                    </v-icon>
                </v-btn>
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
    import SmartTable from "Components/SmartTable";
    import PeriodSelector from "Components/common/PeriodSelector";
    import UserSelector from "Components/common/UserSelector";
    import ACL from "Mixins/acl";
    export default {
        mixins: [ACL],
        extends: SmartTable,
        components: {
            PeriodSelector,
            UserSelector
        },
        data: () => ({
            title: 'Achizitii interne',
            dialog: false,
            loading: true,
            headers: [
                { text: 'Document', value: 'document_no' },
                { text: 'Tip Achizitie', value: 'type' },
                { text: 'Data', value: 'document_date' },
                { text: 'Furnizor', value: 'supplier_id' },
                { text: 'Utilaj', value: 'equipment_id', sortable: false },
                { text: 'Valoare cu TVA', value: 'amount_with_vat' },
                { text: 'Observatii', value: 'remarks' },
                { text: 'Adaugat de', value: 'created_by' },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            options: {
                sortBy: ['created_at'],
                sortDesc: [true]
            },
            editedIndex: -1,
            editedItem: {
                amount: null,
                amount_with_vat: null,
                created_at: null,
                created_by: null,
                data: null,
                deleted_at: null,
                deleted_by: null,
                document_date: null,
                document_no: null,
                equipment: null,
                equipment_id: null,
                id: null,
                supplier: null,
                supplier_id: null,
                updated_at: null,
                updated_by: null,
                workstation_id: null
            },
            defaultItem: {
                amount: null,
                amount_with_vat: null,
                created_at: null,
                created_by: null,
                data: null,
                deleted_at: null,
                deleted_by: null,
                document_date: null,
                document_no: null,
                equipment: null,
                equipment_id: null,
                id: null,
                supplier: null,
                supplier_id: null,
                updated_at: null,
                updated_by: null,
                workstation_id: null
            },
            period: [window.moment().subtract(1, 'month').toISOString(), window.moment().toISOString()],
            filterByUser: null
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            period: {
                async handler(val) {
                    await this.initialize()
                }
            },
            filterByUser: {
                async handler(val) {
                    await this.initialize()
                }
            }
        },

        async created () {
            await this.initialize()
        },

        methods: {
            getQuery(extraParams) {
                let query = this.$db.InternalAquisition
                    .orderBy(this.orderBy)
                    .include('supplier', 'equipment', 'createdBy')
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params(Object.assign({
                        query: this.search
                    }, extraParams))
                if(this.period instanceof Array && this.period.length === 2) {
                    query = query.where('between', [window.moment(this.period[0]).format('YYYY-MM-DD'), window.moment(this.period[1]).format('YYYY-MM-DD')].join(','))
                }
                if(!this._.isNil(this.filterByUser)) query = query.where('created_by', this.filterByUser.join(','))
                return query
            },
            async initialize () {
                this.loading = true
                var query = this.getQuery()
                let { data, meta } = await query.get()
                this.items = data
                this.meta = meta
                this.loading = false
            },

            editItem (e, item) {
                e.preventDefault()
                this.$router.push({ name: 'internal-aquisitions-edit', params: { id: item.id } })
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            save () {
            },

            addNewItem: function(e) {
                e.preventDefault()
                this.$router.push({ name: 'internal-aquisitions-create' })
            },

            canDelete(item) {
                return this.hasRole('admin')
            },

            async deleteItemConfirm () {
                let item = this.items[this.editedIndex]
                if(item instanceof this.$db.InternalAquisition) {
                    await item.delete().catch((err) => {
                        this.showError(err?.response?.data?.error)
                        throw err
                    })
                } else {
                    console.warn('Here comes the headache...')
                }
                this.dialogDelete = false
                await this.initialize()
            },

            async createExport() {
                this.loading = true
                let query = this.getQuery({export: true})
                let base = query._fromResource || `${query.baseURL()}/${query.resource()}`
                base = query._customResource
                    ? `${query.baseURL()}/${query._customResource}`
                    : base
                let url = `${base}${query._builder.query()}`
                return window.axios.get(`${url}`, {
                    responseType: 'blob'
                }).then((response) => {
                    const contentDisposition = this._.get(response, 'headers.content-disposition')
                    const filename = contentDisposition.split("filename=")[1];
                    const downloadUrl = window.URL.createObjectURL(new Blob([response?.data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', filename); //any other extension
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }).catch((err) => {
                    console.error(err)
                }).finally(() => {
                    this.loading = false
                })
            }
        },
    };
</script>
